/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";

import type { ChainbindersMelt } from "../ChainbindersMelt";

export class ChainbindersMelt__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _weth: string,
    _azuki: string,
    _momiji: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ChainbindersMelt> {
    return super.deploy(
      _weth,
      _azuki,
      _momiji,
      overrides || {}
    ) as Promise<ChainbindersMelt>;
  }
  getDeployTransaction(
    _weth: string,
    _azuki: string,
    _momiji: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_weth, _azuki, _momiji, overrides || {});
  }
  attach(address: string): ChainbindersMelt {
    return super.attach(address) as ChainbindersMelt;
  }
  connect(signer: Signer): ChainbindersMelt__factory {
    return super.connect(signer) as ChainbindersMelt__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ChainbindersMelt {
    return new Contract(address, _abi, signerOrProvider) as ChainbindersMelt;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_weth",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "_azuki",
        type: "address",
      },
      {
        internalType: "contract IMomijiToken",
        name: "_momiji",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "nftLevel",
        type: "uint8",
      },
    ],
    name: "CardAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "removedAmount",
        type: "uint256",
      },
    ],
    name: "CardRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "burner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "azukiBurned",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "forUserAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "forDokibuybackAmount",
        type: "uint256",
      },
    ],
    name: "Melt",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "nftLevel",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "ethAmountOfLevel",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "poolRatio",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "azukiRequiredForMelt",
        type: "uint256",
      },
    ],
    name: "SetupRarityLevel",
    type: "event",
  },
  {
    inputs: [],
    name: "auzkiBurnAccount",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "azuki",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "",
        type: "uint8",
      },
    ],
    name: "azukiBurnAmountOfLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "cardAmounWithId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "cardLevelWithId",
    outputs: [
      {
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "dokiBuybackAccount",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "",
        type: "uint8",
      },
    ],
    name: "ethAmountOfLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "momiji",
    outputs: [
      {
        internalType: "contract IMomijiToken",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "",
        type: "uint8",
      },
    ],
    name: "nftCardAmountOfLevel",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "",
        type: "uint8",
      },
    ],
    name: "nftRatio",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "weth",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256",
      },
      {
        internalType: "enum ChainbindersMelt.NftLevel",
        name: "nftLevel",
        type: "uint8",
      },
    ],
    name: "addCard",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
    ],
    name: "removeCard",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "setupInitialETHAmountOfLevel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
    ],
    name: "rarity",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "cardId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "melt",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "changeBuybackAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "changeAzukiBurnAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_forLegendary",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_forEthereal",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_forMythic",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_forRare",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_forCommon",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_forSecret",
        type: "uint256",
      },
    ],
    name: "changeAzukiBurnAmountOfLevel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "start",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "emergencyStop",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
